exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".link-component {\n  display: inherit;\n  width: 100%;\n}\n.link-component a {\n  color: #fff;\n}\n.link-component.comment-style {\n  border-radius: 50%;\n  overflow: hidden;\n  height: 20px;\n  width: 20px;\n}\n.link-component.comment-style img {\n  height: 100%;\n  width: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-oneOf-3-1!./node_modules/less-loader/dist/cjs.js??ref--1-oneOf-3-2!./src/components/LinkComponent/linkComponent.less
// module id = 1284
// module chunks = 0